<!--
  ~ Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->

<ng-template #detailFields>
  <form [formGroup]="form">
    <mat-form-field>
      <input matInput formControlName="siteId" placeholder="siteId" />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input matInput formControlName="siteName" placeholder="Site Name" />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="industryType"
        placeholder="Industry Type"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input matInput formControlName="city" placeholder="City" />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="nextFollowUpDate"
        placeholder="Next Follow UpDate"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="executionState"
        placeholder="Execution State"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input matInput formControlName="leadType" placeholder="Lead Type" />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="conversionFlag"
        placeholder="Conversion Flag"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="featureOpted"
        placeholder="Feature Opted"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="industrySegment"
        placeholder="Industry Segment"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="contactPersonName"
        placeholder="Contact Person Name"
      />
    </mat-form-field>
    <!-- <br> -->
    <mat-form-field>
      <input
        matInput
        formControlName="contactNo"
        placeholder="Contact Number"
      />
    </mat-form-field>
  </form>
</ng-template>

<ng-template #detailActions>
  <button
    mat-button
    (click)="cancel()"
    [routerLink]="['..']"
    style="margin-left: 16px"
  >
    Cancel
  </button>
</ng-template>

<ng-template #withSidebar>
  <button
    class="close-button"
    mat-icon-button
    type="button"
    [routerLink]="['..']"
  >
    <mat-icon
      fontIcon="Bosch-Ic-abort"
      style="font-size: 16px"
      fontSet="bosch"
    ></mat-icon>
  </button>
  <div style="width: 100%">
    <ng-container *ngTemplateOutlet="detailFields"></ng-container>
  </div>
  <div>
    <ng-container *ngTemplateOutlet="detailActions"></ng-container>
  </div>
</ng-template>

<ng-template #withDialog>
  <div [ngStyle]="{ height: '100%' }">
    <mat-card style="height: inherit; overflow: hidden">
      <mat-card-title>Details</mat-card-title>
      <mat-card-content>
        <ng-container *ngTemplateOutlet="detailFields"></ng-container>
      </mat-card-content>
      <mat-card-actions>
        <ng-container *ngTemplateOutlet="detailActions"></ng-container>
      </mat-card-actions>
    </mat-card>
    <button
      class="close-button-dialog"
      mat-icon-button
      type="button"
      [routerLink]="['..']"
    >
      <mat-icon
        fontIcon="Bosch-Ic-abort"
        style="font-size: 16px"
        fontSet="bosch"
      ></mat-icon>
    </button>
  </div>
</ng-template>

<ng-container
  *ngTemplateOutlet="masterDetailView.useDialog ? withDialog : withSidebar"
></ng-container>
